const teamwork = {
  path: 'teamwork',
  component: resolve => require(['../../../pages/teamwork'], resolve)
}

export default teamwork
